import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "IX. Subjective Symptoms / 自覚症状", -1)
const _hoisted_3 = { class: "mb-4 space-y-1 text-darkgray-800" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Check if you are experiencing any of the following / 次のいずれかの症状がある場合には、下記のボックスにチェックを入れてください。", -1)
const _hoisted_5 = {
  key: 0,
  class: "text-[10px] mt-1 text-red-600"
}
const _hoisted_6 = {
  key: 1,
  class: "text-[10px] mt-1 text-red-600"
}
const _hoisted_7 = { class: "space-y-3 lg:columns-2" }
const _hoisted_8 = { class: "col-span-6 mt-3 pl-7" }

import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import MedicalService from '@/classes/MedicalService';
import TextInput from '@/components/inputs/TextInput.vue';
import { computed, ref, watch, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ObjectiveSymptoms',
  props: {
    form: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: false
    },
    errors: {
        type: Array,
        required: true
    },
},
  setup(__props) {

const props = __props

const symptoms = MedicalService.getSymptoms()
const item = ref(props.form)
const others = ref<string>('')
const showOthers = ref<boolean>(false)
const isShowingOthers = ref<boolean>(false);

const selectedVal = computed(() => item.value?.map(a => a.symptoms));



const addSymptom = (symptoms: string, val: boolean) => {
    console.log("Adding symptom:", symptoms, "with value:", val);
    // If "None" is selected, clear all other symptoms
    if (symptoms === "None") {
        console.log("Adding 'None' symptom, clearing others");
        for (let i = item.value.length - 1; i >= 0; i--) {
            item.value.splice(i, 1);
        }
        
        // item.value = [{ symptoms: "None", is_checked: true }];
        if(!val) {
            item.value.push({ symptoms: "None",  is_checked: !val })
        }
        showOthers.value = false;
        isShowingOthers.value = false;
        others.value = '';
        return;
    }
    
    // If any other symptom is selected while "None" is checked, remove "None"
    const noneIndex = item.value.findIndex(i => i.symptoms === "None");
    if (noneIndex !== -1) {
        item.value.splice(noneIndex, 1);
    }

    if(!item.value.some(e => e.symptoms === symptoms)) {
        item.value.push({ symptoms,  is_checked: true })
    } else {
        item.value.splice(item.value.findIndex(i => i.symptoms === symptoms), 1);
    }
}

const othersSymptoms = () => {
    console.log("Updating Others Symptoms with:", others.value);
    const index = item.value.findIndex(i => i.symptoms === "Others");
    if (!props.disableInputs && others.value !== '') {  
    
        if (index != -1) {
            item.value.splice(index, 1);
        } 
        
        item.value.push({ symptoms: "Others", is_checked: true, "others_description": others.value })
    } 
}

watch(
    () => others.value,
    () => {
        if(others.value) {
            othersSymptoms()
        }
    }
);

watch(
    () => showOthers.value,
    () => {
        console.log("showOthers changed:", showOthers.value);
        if (showOthers.value) {
            console.log("showOthers is true");
            item.value.push({ symptoms: "Others", is_checked: true, "others_description": others.value })
        } else {
            console.log("showOthers is false");
            const othersIndex = item.value.findIndex(i => i.symptoms === "Others");
            if (othersIndex !== -1) {
                item.value.splice(othersIndex, 1);
            }
            isShowingOthers.value = false;
            others.value = '';
        }
    }
)

onMounted(() => {
    showOthers.value = item.value.some(i => i.symptoms === "Others");
    isShowingOthers.value = item.value.some(i => i.symptoms === "Others");
    others.value = item.value.find(i => i.symptoms === "Others")?.others_description || '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (__props.errors[`subjective_symptoms`])
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.errors[`subjective_symptoms`][0]), 1))
        : _createCommentVNode("", true),
      (__props.errors[`subjective_symptoms.experience`])
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.errors[`subjective_symptoms.experience`][0]), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(symptoms), (i) => {
        return (_openBlock(), _createBlock(CheckboxInput, {
          key: i,
          id: i.label,
          label: i.label,
          rounded: false,
          disabled: __props.disableInputs,
          "is-checked": selectedVal.value.includes(i.value),
          "text-color": "text-darkgray-800",
          onChange: ($event: any) => (addSymptom(i.value, selectedVal.value.includes(i.value)))
        }, null, 8, ["id", "label", "disabled", "is-checked", "onChange"]))
      }), 128)),
      _createVNode(CheckboxInput, {
        modelValue: showOthers.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showOthers).value = $event)),
        id: "others",
        rounded: false,
        disabled: __props.disableInputs,
        "text-color": "text-darkgray-800",
        "is-checked": showOthers.value,
        label: "Others /その他"
      }, null, 8, ["modelValue", "disabled", "is-checked"]),
      _createElementVNode("div", _hoisted_8, [
        (showOthers.value)
          ? (_openBlock(), _createBlock(TextInput, {
              key: 0,
              modelValue: others.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((others).value = $event)),
              id: "test_result_others",
              type: "text",
              placeholder: "Type here",
              error: __props.errors['subjective_symptoms.others_description'] ? __props.errors['subjective_symptoms.others_description'][0] : ''
            }, null, 8, ["modelValue", "error"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})